import React,{useState} from 'react'
import API from '../../../../../API/API'
import $ from 'jquery'
const IsInboundActive = (props) => {
    const [isLoading, setIsLoading] = useState(false)
    const changeStatus = (event) => {
        setIsLoading(true)
        $(event.target).parents("tr").find("td:nth-child(3) input").attr("id",JSON.parse(event.target.checked))
        let entityId = event.target.name
        var response =window.localStorage.getItem("accessToken");
        const headers={
            "authorization": `Bearer ${response}`,
            "content-type" : "application/json"
        };
        const body = {
            "isInboundActive" : event.target.checked,
            "isOutboundActive": JSON.parse(event.target.id)
        }
        API.post(`/Connection/${props.connectorId}/instance/${props.instancesId}/entities/${entityId}`, body, { headers })
        .then((response) => {
            if(response.status === 200){
                props.getStatus(response)
                setIsLoading(false)
                props.getMessage(response.data.result)
            }
        })
    }
    return (
        <>
            <td>
                {isLoading ?
                    <div className="loaderNewContainer">
                        <div className="loading-spinner"></div>
                    </div> : null
                }
                <label class="switch">
                    <input type="checkbox"
                        id={props.id.toString()}
                        name={props.name}
                        defaultChecked={props.isInboundActive}
                        disabled={props.isInboundEditable === true ? false : true}
                        onClick={changeStatus}
                    />
                    <span class="slider round"></span> 
                </label>
            </td>
        </>
    )
}

export default IsInboundActive
